import { Component, OnInit } from '@angular/core';
import { PromptService } from '../../../services/prompt.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-about-catch',
  templateUrl: './about-catch.component.html',
  styleUrls: ['./about-catch.component.scss'],
  standalone: false,
})
export class AboutCatchComponent implements OnInit {
  public version = '';
  constructor(private promptsService: PromptService) {}

  ngOnInit() {
    this.version = environment.version;
  }

  get prompts() {
    return this.promptsService.prompts;
  }
}
